/**
 * View Manager — registry for named views.
 * Each view implements { activate(), deactivate(), applyLayout() }.
 */
export class ViewManager {
    constructor() {
        this.views = new Map();
        this.activeView = null;
    }

    register(name, view) {
        this.views.set(name, view);
    }

    switchTo(name) {
        this.activeView?.deactivate();
        this.activeView = this.views.get(name);
        if (!this.activeView) throw new Error(`View '${name}' not registered`);
        this.activeView.activate();
    }

    applyLayout() {
        this.activeView?.applyLayout();
    }
}
